/* eslint-disable @typescript-eslint/prefer-readonly-parameter-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable functional/prefer-readonly-type */

/**
 * The remove duplicate function is used to remove element that duplicate into array.
 * And return the list unique.
 *
 * @param array T[]
 * @param key string
 * @returns array
 */
export function removeDuplicate<T>(array: T[], key: string): T[] {
  const uniqueValues = new Set();

  return (
    array?.filter((obj: any) => {
      // check if name property value is already in the set
      const isPresent = uniqueValues.has(obj[key]);

      // add name property value to Set
      uniqueValues.add(obj[key]);

      return !isPresent;
    }) ?? []
  );
}
